module.exports = __webpack_public_path__ + "static/zavitz-logo-85bc2cd6c0a77403c7da834be74150d1.jpg";